class ShopCollectionsTabs extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('.shop-collections__tab');
        this.panels = this.querySelectorAll('.shop-collections__panel');
        this.isMobile = window.innerWidth <= 989;
        this.init();
    }

    init() {
        this.attachTabListeners();
        this.initializePanels();
        this.handleResize();
        this.initCustomizerListeners();
    }

    initCustomizerListeners() {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) {
                this.init();
            }
        });
    }

    attachTabListeners() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => this.handleTabClick(e));
        });
    }

    handleTabClick(e) {
        const clickedTab = e.currentTarget;
        const tabId = clickedTab.dataset.tabId;

        this.tabs.forEach((tab) => tab.classList.remove('is-active'));
        clickedTab.classList.add('is-active');

        this.panels.forEach((panel) => panel.classList.remove('is-active'));
        const activePanel = this.querySelector(`[data-panel-id="${tabId}"]`);
        if (activePanel) {
            activePanel.classList.add('is-active');
            this.initializeCollections(activePanel);
        }
    }

    initializePanels() {
        this.panels.forEach((panel, index) => {
            if (index === 0) {
                this.initializeCollections(panel);
            }
        });
    }

    initializeCollections(panel) {
        const collectionItems = panel.querySelectorAll('.shop-collections__item');
        const sliders = panel.querySelectorAll('.shop-collections__slider');

        collectionItems.forEach((item, index) => {
            const eventType = this.isMobile ? 'click' : 'mouseenter';

            item.addEventListener(eventType, () => {
                collectionItems.forEach((ci) => ci.classList.remove('is-active'));
                item.classList.add('is-active');

                sliders.forEach((slider) => slider.classList.remove('is-active'));
                if (sliders[index]) {
                    sliders[index].classList.add('is-active');
                    this.initializeSlider(sliders[index]);
                }
            });
        });

        if (sliders[0]) {
            this.initializeSlider(sliders[0]);
        }
    }

    initializeSlider(slider) {
        const track = slider.querySelector('.shop-collections__slider-track');
        const dotsContainer = slider.querySelector('.shop-collections__dots');

        if (!track || !dotsContainer) return;

        const totalProducts = parseInt(dotsContainer.dataset.totalProducts);
        const itemsPerSlide = window.innerWidth <= 989 ? 2 : 3;
        const totalSlides = Math.ceil(totalProducts / itemsPerSlide);

        // Clear existing dots and regenerate
        dotsContainer.innerHTML = '';
        if (totalSlides > 1) {
            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement('button');
                dot.className = `shop-collections__dot${i === 0 ? ' is-active' : ''}`;
                dot.dataset.slide = i;
                dot.ariaLabel = `Go to slide ${i + 1}`;
                dotsContainer.appendChild(dot);
            }
        }

        const dots = dotsContainer.querySelectorAll('.shop-collections__dot');
        dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                const slideIndex = parseInt(dot.dataset.slide);
                this.scrollToSlide(track, slideIndex, dots);
            });
        });

        track.addEventListener('scroll', () => {
            this.updateActiveDot(track, dots);
        });
    }

    scrollToSlide(track, index, dots) {
        const productElement = track.querySelector('.shop-collections__product');
        if (!productElement) return;

        const productWidth = productElement.offsetWidth;
        const gap = 15;
        const itemsPerSlide = window.innerWidth <= 989 ? 2 : 3;
        const scrollPosition = index * (productWidth * itemsPerSlide + gap * itemsPerSlide);

        track.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
        });

        dots.forEach((dot) => dot.classList.remove('is-active'));
        if (dots[index]) {
            dots[index].classList.add('is-active');
        }
    }

    updateActiveDot(track, dots) {
        const productElement = track.querySelector('.shop-collections__product');
        if (!productElement) return;

        const scrollLeft = track.scrollLeft;
        const productWidth = productElement.offsetWidth;
        const gap = 15;
        const itemsPerSlide = window.innerWidth <= 989 ? 2 : 3;
        const slideWidth = productWidth * itemsPerSlide + gap * itemsPerSlide;
        const currentSlide = Math.round(scrollLeft / slideWidth);

        dots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('is-active');
            } else {
                dot.classList.remove('is-active');
            }
        });
    }

    handleResize() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const wasMobile = this.isMobile;
                this.isMobile = window.innerWidth <= 989;

                if (wasMobile !== this.isMobile) {
                    const activePanel = this.querySelector('.shop-collections__panel.is-active');
                    if (activePanel) {
                        this.initializeCollections(activePanel);
                    }
                }
            }, 250);
        });
    }
}

customElements.define('shop-collections-tabs', ShopCollectionsTabs);
